import * as React from "react";
import type { SVGProps } from "react";
const SvgNavigationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#navigation-icon_svg__a)">
      <path
        fill="currentColor"
        d="M12 2 4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
      />
    </g>
    <defs>
      <clipPath id="navigation-icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNavigationIcon;
